exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blog-list-page .tag{display:flex;align-items:flex-end}.blog-list-page .tag b{font-size:20px;color:#fbba14;font-weight:700}.blog-list-page .tag button{margin-left:1em;display:inline-flex;align-items:center;gap:4px}.blog-list-page .tag button:hover{color:#fbba14}.blog-list-page .tag button svg{height:1em;margin-bottom:4px}", ""]);

// exports
